// import { getIsoCountryList, identityForeignFourFactorAuth } from '@/api/user';

export const iDCardTypes = [
  { value: '身份证', label: '身份证' },
  { value: '定居国外的中国公民护照', label: '定居国外的中国公民护照' },
  { value: '港澳居民来往内地通行证', label: '港澳居民来往内地通行证' },
  { value: '台湾居民来往内地通行证', label: '台湾居民来往内地通行证' },
  { value: '外国人永久居留身份证', label: '外国人永久居留身份证' },
];

export const iDCardTypesLabel = (val) => {
  const obj = iDCardTypes.find(item => item.value === val);
  if (obj) return obj.label;
  return val;
};

export const isCHCard = val => val === '身份证';

// export const getCountryList = async () => {
//   const res = await getIsoCountryList();
//   const { code, data } = res;
//   if (code === 0) {
//     return (data.list || []).sort((c1, c2) => (c1.namePinyin < c2.namePinyin ? -1 : 1));
//   }
//   return [];
// };

/**
 * 验证证件号码是否正确
 * @param {*} postData
 * {
 *  userName: '' // 姓名
 *  userDocumentNo: '' // 证件号码
 *  userIdType: '' // 证件类型
 *  userCountry: '' // 证件国籍
 * }
 * @returns
 */
// export const vertifyIDCard = async (postData) => {
//   if (postData.userIdType === '身份证') return true;
//   const res = await identityForeignFourFactorAuth(postData);
//   if (res.code === 0) return true;
//   return false;
// };

export const formatOldCatType = (type) => {
  if (type === '身份证' || type === '身份证') return '身份证';
  return type;
};

export const isForeign = type => type === '外国人永久居留身份证';
